import { ICreateFuncionarioAprovadorUseCase } from "../../../presentation/useCases/create/create_funcionario_aprovador_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateFuncionarioAprovadorUseCase
 */

export class CreateFuncionarioAprovadorUseCase implements ICreateFuncionarioAprovadorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createFuncionarioAprovador(
    idFuncionario: number,
    funcionarioEmail: string,
    valorMaximo: number | null,
  ): Promise<void> {
    await this.repository.createFuncionarioAprovador(
      idFuncionario, funcionarioEmail, valorMaximo);
  }
}
